import { FC } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

type AppCardProps = {
  label: string | undefined;
  value: string | number | undefined;
  loader?: boolean;
};

const AppCard: FC<AppCardProps> = (props) => {
  return (
    <Box
      sx={{
        height: "fit-content",
        backgroundColor: "rgba(255, 255, 255, 0.07);",
        borderRadius: "8px",
        padding: "30px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        minHeight: "8em",
      }}
    >
      <Typography
        variant="body2"
        component="span"
        sx={{
          color: "#B6B9BE",
        }}
      >
        {props.label}
      </Typography>
      {!!props.loader ? (
        <div style={{ height: "30px", width: "30px" }}>
          <CircularProgress color="primary" sx={{ marginTop: 1 }} />
        </div>
      ) : (
        <Typography
          sx={{
            color: "#FFFFFF",
          }}
          style={{ wordBreak: "break-word" }}
          component="span"
        >
          {props.value}
        </Typography>
      )}
    </Box>
  );
};

export default AppCard;
